// extracted by mini-css-extract-plugin
export default {"textWrapper":"mfr-kuxcTBgI","pageWrapper":"mfr-uOqbtBcg","contentWrapper":"mfr-DkJgO0Rc","extraPaddingLeft":"mfr-ygCS13r2","notFoundWrapper":"mfr-cS7o8RE5","halfLogo":"mfr-mXQmpaAk"};